export const STRATEGY_DATA_CONFIG = {
  // crud的模态框表单配置，可配置表单类型，验证规则，是否必填,col-span布局可通过span参数配置
  formConfig: [
    { span: 24,
      label: '作者',
      prop: 'author',
      type: 'text',
      rules: { required: true,
        message: '请输入作者名称',
        trigger: 'blur'
      },
      data: []
    },
    { span: 24,
      label: '生成DAO',
      prop: 'createMapper',
      type: 'select',
      rules: {
        required: true,
        message: '请选择生成DAO',
        trigger: 'change'
      },
      dataScource: '5396f45325844eb4382ad6aa130429dd',
      data: []
    },
    { span: 24,
      label: '生成Service',
      prop: 'createService',
      type: 'select',
      rules: {
        required: true,
        message: '请选择生成Service',
        trigger: 'change'
      },
      dataScource: '5396f45325844eb4382ad6aa130429dd',
      data: []
    },
    { span: 24,
      label: '生成Controller',
      prop: 'createController',
      type: 'select',
      rules: {
        required: true,
        message: '请选择生成Controller',
        trigger: 'change'
      },
      dataScource: '5396f45325844eb4382ad6aa130429dd',
      data: []
    },
    { span: 24,
      label: '生成前端',
      prop: 'createFront',
      type: 'select',
      rules: {
        required: true,
        message: '请选择生成前端',
        trigger: 'change'
      },
      dataScource: '5396f45325844eb4382ad6aa130429dd',
      data: []
    },
    { span: 24,
      label: '前端路径',
      prop: 'frontPath',
      type: 'text',
      data: []
    },
    { span: 24,
      label: '后端路径',
      prop: 'backPath',
      type: 'text',
      data: []
    },
    { span: 24,
      label: '包名',
      prop: 'packageName',
      type: 'text',
      data: []
    },
    { span: 24,
      label: '模块',
      prop: 'frontModule',
      type: 'text',
      data: []
    },
    { span: 24,
      label: '表前缀',
      prop: 'tablePrefix',
      type: 'text',
      data: []
    }
  ],
  dialogConfig: {
    labelWidth:'120px'
  },
  // crud的操作按钮配置，基础按钮有添加、修改、删除、查看，还可以配置扩展按钮
  gridBtnConfig: {
    create: true, update: true, delete: true, view: false
  },
  // 表单基础数据类型，需要预先赋值
  formModel: {
    'id': '',
    'author': '',
    'createMapper': '',
    'createService': '',
    'createController': '',
    'createFront': '',
    'frontPath': '',
    'backPath': '',
    'frontModule': '',
    'tableId': '',
    'tablePrefix':'',
    'packageName':''
  },
  queryModel: {
  }
}




// WEBPACK FOOTER //
// ./src/components/generator/createCode/config/strategy.js